'use client';
import Image from '@/types/Image';
import Carousel from '@avtopro/carousel/dist/index';
import NextImage from 'next/image';

const Gallery = ({ images }: { images: Image[] }) => {
	return (
		<Carousel showThumbnails={true} thumbnailsClassName="thumbs-container">
			{images.map(({ src, alt }, index) => (
				<span
					key={src}
					className="card-item sm:w-66 h-54 md:w-66 md:h-46 xl:w-110 xl:h-76 relative w-full overflow-hidden rounded">
					<NextImage
						src={src}
						alt={alt}
						fill
						priority={index == 0}
						className="h-full w-full object-cover"
					/>
				</span>
			))}
		</Carousel>
	);
};

export default Gallery;
